import styles from "../../styles/DocentesStyles/PantallaDocentes.module.css";

const StatusBadge = ({ status, children }) => {
  const getStatusClass = () => {
    switch (status) {
      case 'active':
        return styles.activeStatus;
      case 'inactive':
        return styles.inactiveStatus;
      case 'baja':
        return styles.bajaStatus;
      default:
        return styles.activeStatus;
    }
  };

  const getContainerClass = () => {
    switch (status) {
      case 'active':
        return styles.activeContainer;
      case 'inactive':
        return styles.inactiveContainer;
      case 'baja':
        return styles.bajaContainer;
      default:
        return styles.activeContainer;
    }
  };

  return (
    <div className={getStatusClass()}>
      <div className={getContainerClass()}>
        <span>{children}</span>
      </div>
    </div>
  );
};

export default StatusBadge;
